import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { productSelector } from '@shared/selectors/product.selectors';
import { CART_SYNC_ACTIONS } from '@usf/ngrx-order';
import { of, combineLatest } from 'rxjs';
import { withLatestFrom, map, switchMap, mergeMap, take } from 'rxjs/operators';
import { CartSyncTracingService } from './cart-sync-tracing.service';
import { CART_SYNC_TRACING_ACTIONS } from './cart-sync-tracing.actions';
import { OrderService } from '@order/services/order.service';

@Injectable({
  providedIn: 'root',
})
export class CartSyncTracingEffects {
  traceCartSync$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CART_SYNC_ACTIONS.cartSync),
      mergeMap(payload => {
        return combineLatest([
          of(payload),
          this.orderService.getProductsForTracing$(payload?.order?.orderItems),
        ]).pipe(take(1));
      }),
      map(([payload, productMap]) =>
        CartSyncTracingService.createCartSyncTrace(
          payload.order,
          productMap,
          true,
          false,
        ),
      ),
      switchMap(tracking => {
        return of(CART_SYNC_TRACING_ACTIONS.traceCartSync({ tracking }));
      }),
    ),
  );
  traceCartSyncSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CART_SYNC_ACTIONS.cartSyncSuccess),
      mergeMap(payload => {
        return combineLatest([
          of(payload),
          this.orderService.getProductsForTracing$(payload?.order?.orderItems),
        ]).pipe(take(1));
      }),
      map(([payload, productMap]) =>
        CartSyncTracingService.createCartSyncTrace(
          payload.order,
          productMap,
          false,
          true,
        ),
      ),
      switchMap(tracking => {
        return of(CART_SYNC_TRACING_ACTIONS.traceCartSyncSuccess({ tracking }));
      }),
    ),
  );

  traceCartSyncFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CART_SYNC_ACTIONS.cartSyncFail),
      map(payload =>
        CartSyncTracingService.createCartSyncFailTrace(payload.error),
      ),
      switchMap(tracking => {
        return of(CART_SYNC_TRACING_ACTIONS.traceCartSyncFail({ tracking }));
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private orderService: OrderService,
  ) {}
}
